export default __webpack_public_path__ + "f7ef785e2893c7fe58576111573067e1.png";